var exports = {
  "l": "x31de4314--c403b1--phone",
};

module.exports = exports;
